import React from 'react';
import Section from '../components/global/section';
import mdToHtml from '../util/mdToHtml';
import styled from 'styled-components';

const StyledPrivacy = styled.div`
	h1 {
		margin-bottom: 1rem;
	}
	a {
		color: ${(p) => p.theme.color.red};
		&:hover {
			color: ${(p) => p.theme.color.blue};
		}
	}
`;

export default ({ data }) => (
	<StyledPrivacy>
		<Section bg="light">
			<h1>{data.title}</h1>
			<div
				className="md-content"
				dangerouslySetInnerHTML={{
					__html: mdToHtml(data.mdContent),
				}}
			/>
		</Section>
	</StyledPrivacy>
);
